import * as _ from 'lodash';

export class Paginator<T>{
    hasMore: boolean;
    hasLess: boolean;

    private _pageNumber = 0;
    private _pageSize = 48;
    private _pageCount: number = 0;

    private _items: T[];
    items(): T[];
    items(value: T[]): this;
    items(value?: T[]): T[] | this {
        if (arguments.length) {
            this._items = value;
            this._pageCount = Math.ceil(value.length / this._pageSize);
            this.paginate();
            return this;
        }
        return this._items;
    }

    private _displayed: T[];
    displayed(): T[] {
        return this._displayed;
    }

    constructor() {
        this._items = [];
        this._displayed = [];
    }

    more(): T[] {
        if (this._pageNumber < this._pageCount - 1) {
            this._pageNumber++;
            this.paginate();
        }
        return this._displayed;
    }

    less(): T[] {
        if (this._pageNumber > 0) {
            this._pageNumber--;
            this.paginate();
        }
        return this._displayed;
    }

    paginate(): T[] {
        const items = this._items;
        if (items) {
            const displayed = this.page(items);
            this._displayed = displayed;
        } else {
            this._displayed = [];
        }
        return this._displayed;
    }

    private page(list: T[]): T[] {
        const displayed = _.take(list, (this._pageNumber + 1) * this._pageSize);
        this.hasMore = this._pageNumber < this._pageCount - 1;
        this.hasLess = this._pageNumber > 0;
        return displayed;
    }
}